import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Container, Row } from 'reactstrap'
import * as Navigation from './Navigation'

import ModalContainer from './admin/ModalContainer'
import UsersContainer from './admin/UsersContainer'
import UserActivityContainer from './admin/UserActivityContainer'
import VideosContainer from './admin/VideosContainer'
import PostsContainer from './admin/PostsContainer'
import DataContainer from './admin/DataContainer'

import BaselineEvaluationContainer from './participant/BaselineEvaluationContainer'
import RegistrationExtrasContainer from './participant/RegistrationExtrasContainer'
import GetTheAppContainer from './participant/GetTheAppContainer'

import Resource from './Resource'

import './styles/index.css'
import StudiesContainer from './admin/StudiesContainer'

class App extends Component {
  render() {
    console.log("Inside app", process.env)
    return (
      <Resource path={['me']} placeholder={null}>
        {(me, { onSave }) => {
          if (!me) {
            return <div className="App">Loading...</div>
          }
          return me.isAdmin || me.role == 2 ? (
            <div className="App">
              <Navigation.Top me={me} />
              <Container fluid>
                <Row>
                  <Navigation.Left me={me} />
                  <main className="col-md-9 col-lg-9 ml-sm-auto col-lg-10 px-4" role="main">
                    <Switch>
                      <Route exact path="/users/:id" render={() => <UserActivityContainer />} />
                      <Route exact path="/studies">
                        <StudiesContainer me={me} />
                      </Route>
                      <Route exact path="/posts">
                        <PostsContainer me={me} />
                      </Route>
                      {me.isAdmin ? (
                        <Route exact path="/videos" render={() => <VideosContainer />} />
                      ) : null}
                      <Route exact path="/data">
                        <DataContainer me={me} />
                      </Route>
                      <Route exact path="/users">
                        <UsersContainer me={me} />
                      </Route>
                    </Switch>
                  </main>
                </Row>
              </Container>
              <ModalContainer />
            </div>
          ) : (
            <main className="participant">
              <Switch>
                <Route
                  exact
                  path="/welcome/1"
                  render={() => <RegistrationExtrasContainer me={me} onSave={onSave} />}
                />
                <Route
                  exact
                  path="/welcome/2"
                  render={() => <BaselineEvaluationContainer me={me} onSave={onSave} />}
                />
                <Route exact path="/get-the-app" render={() => <GetTheAppContainer me={me} />} />
                <Route
                  element={
                    me.profile && Object.keys(me.profile).length ? (
                      <Redirect to="/get-the-app" />
                    ) : (
                      <Redirect to="/welcome/1" />
                    )
                  }
                />
              </Switch>
            </main>
          )
        }}
      </Resource>
    )
  }
}

export default App
